import React, { useEffect, useState } from 'react';
import { apiCall } from '../utils/auth';

const COR = 'rgb(235, 133, 0)';
const formatBRL = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const TIPOS_PADRAO = ['Pix', 'Dinheiro', 'Cartão de crédito', 'Cartão de débito'];

// Pagamento externo: valor pago FORA do sistema (dinheiro, Pix direto, maquininha...), total ou parcial.
// Parcial: só desconta do valor da venda. Total: a venda é aprovada e a entrega do produto é gerada.
export default function PopupPagamentoExterno({ vendaId, onFechar, onSalvo }) {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [valor, setValor] = useState('');
  const [tipo, setTipo] = useState('');
  const [confirmando, setConfirmando] = useState(false);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setDados(await apiCall(`Vendas/${vendaId}/pagamentos-externos`));
      } catch (e) {
        setErro('Não foi possível carregar os dados da venda.');
      }
    })();
  }, [vendaId]);

  const restante = Number(dados?.valorRestante ?? dados?.ValorRestante ?? 0);
  const valorFinal = Number(dados?.valorFinal ?? dados?.ValorFinal ?? 0);
  const totalPago = Number(dados?.totalPagoExterno ?? dados?.TotalPagoExterno ?? 0);
  const pagamentos = dados?.pagamentos ?? dados?.Pagamentos ?? [];
  const tipos = dados?.tiposPagamento ?? dados?.TiposPagamento ?? TIPOS_PADRAO;
  const valorNum = Math.round((parseFloat(String(valor).replace(',', '.')) || 0) * 100) / 100;
  const ehTotal = valorNum > 0 && Math.abs(valorNum - restante) < 0.005;

  const pedirConfirmacao = () => {
    setErro('');
    if (valorNum <= 0) { setErro('Informe o valor pago fora do sistema.'); return; }
    if (valorNum > restante + 0.005) { setErro(`O valor não pode passar do que falta pagar (${formatBRL(restante)}).`); return; }
    if (!tipo) { setErro('Escolha a forma de pagamento.'); return; }
    setConfirmando(true);
  };

  const salvar = async () => {
    try {
      setSalvando(true);
      const r = await apiCall(`Vendas/${vendaId}/pagamento-externo`, 'POST', { valor: valorNum, tipoPagamento: tipo });
      const quitada = r?.quitada ?? r?.Quitada;
      const aviso = r?.aviso ?? r?.Aviso;
      alert(quitada
        ? `Pagamento externo registrado. A venda foi totalmente paga${(r?.aprovadaAgora ?? r?.AprovadaAgora) ? ', aprovada e a entrega do produto foi gerada' : ''}.${aviso ? '\n\n' + aviso : ''}`
        : `Pagamento externo registrado. Ainda falta pagar ${formatBRL(r?.valorRestante ?? r?.ValorRestante)}.`);
      onSalvo && onSalvo();
      onFechar && onFechar();
    } catch (e) {
      let msg = e.message || String(e);
      try { msg = JSON.parse(msg).mensagem || msg; } catch { /* texto simples */ }
      setConfirmando(false);
      setErro(msg);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 95000, padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto', background: '#fff', borderRadius: 12, padding: 22, boxShadow: '0 8px 30px rgba(0,0,0,0.25)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, marginBottom: 10 }}>
          <h3 style={{ margin: 0, color: COR }}>💵 Pagamento externo · Venda #{vendaId}</h3>
          <button onClick={onFechar} aria-label="Fechar" title="Fechar" style={{ flexShrink: 0, backgroundColor: COR, color: '#fff', border: 'none', borderRadius: '50%', width: 36, height: 36, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, lineHeight: 1, cursor: 'pointer' }}>×</button>
        </div>

        <p style={{ margin: '0 0 14px', color: '#444', fontSize: 14, lineHeight: 1.5 }}>
          Registre aqui um pagamento feito <strong>fora do sistema</strong> (por exemplo, uma entrada em dinheiro, um Pix direto ou a maquininha de cartão).
          Pode ser <strong>parcial</strong>: o valor é descontado do total da venda e o restante continua a pagar.
          Ou o <strong>total</strong>: a venda é aprovada e a entrega do produto é gerada automaticamente.
        </p>

        {dados && (
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
            {[['Valor da venda', valorFinal, '#333'], ['Já pago por fora', totalPago, '#1565c0'], ['Falta pagar', restante, '#2e7d32']].map(([rotulo, v, cor]) => (
              <div key={rotulo} style={{ flex: '1 1 140px', padding: 10, background: '#fafafa', border: '1px solid #eee', borderRadius: 8 }}>
                <div style={{ fontSize: 12, color: '#777' }}>{rotulo}</div>
                <div style={{ fontSize: 17, fontWeight: 800, color: cor }}>{formatBRL(v)}</div>
              </div>
            ))}
          </div>
        )}

        {dados && restante <= 0 ? (
          <div style={{ padding: 12, background: '#e8f5e9', color: '#2e7d32', borderRadius: 8, fontWeight: 600 }}>Esta venda já foi totalmente paga.</div>
        ) : (
          <>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
              <label style={{ flex: '1 1 180px', display: 'flex', flexDirection: 'column', fontSize: 13, fontWeight: 600 }}>
                Valor pago externamente (R$)
                <input type="number" min="0" step="0.01" value={valor} onChange={(e) => setValor(e.target.value)} placeholder="0,00"
                  style={{ marginTop: 6, padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 15 }} />
              </label>
              <label style={{ flex: '1 1 180px', display: 'flex', flexDirection: 'column', fontSize: 13, fontWeight: 600 }}>
                Forma de pagamento
                <select value={tipo} onChange={(e) => setTipo(e.target.value)} style={{ marginTop: 6, padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 15 }}>
                  <option value="">Selecione...</option>
                  {tipos.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </label>
              <button type="button" onClick={() => setValor(restante.toFixed(2))} style={{ padding: '10px 12px', background: '#fff', color: COR, border: `1px solid ${COR}`, borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
                Valor total
              </button>
            </div>
            {valorNum > 0 && valorNum <= restante + 0.005 && (
              <div style={{ marginTop: 8, fontSize: 13, color: ehTotal ? '#2e7d32' : '#555' }}>
                {ehTotal ? 'Pagamento TOTAL: a venda será aprovada e a entrega gerada.' : `Pagamento parcial: depois disso faltarão ${formatBRL(restante - valorNum)}.`}
              </div>
            )}
            {erro && <div style={{ marginTop: 10, color: '#d32f2f', fontWeight: 600, fontSize: 13 }}>{erro}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
              <button type="button" className="btn-cancelar-forte" onClick={onFechar} style={{ padding: '10px 18px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 600 }}>Cancelar</button>
              <button type="button" onClick={pedirConfirmacao} disabled={!dados} style={{ padding: '10px 22px', background: COR, color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 700 }}>Salvar</button>
            </div>
          </>
        )}

        {pagamentos.length > 0 && (
          <div style={{ marginTop: 18 }}>
            <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 6 }}>Pagamentos externos desta venda</div>
            {pagamentos.map(p => (
              <div key={p.id ?? p.Id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
                <span>{p.tipoPagamento ?? p.TipoPagamento} · {String(p.dataHora ?? p.DataHora ?? '').replace('T', ' ').slice(0, 16)}</span>
                <strong>{formatBRL(p.valor ?? p.Valor)}</strong>
              </div>
            ))}
          </div>
        )}
      </div>

      {confirmando && (
        <div onClick={(e) => { e.stopPropagation(); if (!salvando) setConfirmando(false); }} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 95010, padding: 16 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 440, background: '#fff', borderRadius: 12, padding: 22, boxShadow: '0 8px 30px rgba(0,0,0,0.3)' }}>
            <h3 style={{ margin: '0 0 10px', color: COR }}>Tem certeza?</h3>
            <p style={{ margin: '0 0 18px', color: '#444', fontSize: 14, lineHeight: 1.5 }}>
              {ehTotal
                ? <>O <strong>valor total</strong> ({formatBRL(valorNum)}) foi pago externamente em <strong>{tipo}</strong>. Ao confirmar, <strong>esta venda será finalizada: ela será aprovada e a entrega do produto será gerada</strong>.</>
                : <>Ao confirmar, <strong>{formatBRL(valorNum)}</strong> pagos em <strong>{tipo}</strong> serão <strong>descontados do valor da venda</strong>. Ainda faltará pagar {formatBRL(restante - valorNum)}.</>}
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              <button type="button" className="btn-cancelar-forte" disabled={salvando} onClick={() => setConfirmando(false)} style={{ padding: '10px 18px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 600 }}>Não</button>
              <button type="button" disabled={salvando} onClick={salvar} style={{ padding: '10px 22px', background: COR, color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 700 }}>{salvando ? 'Salvando...' : 'Sim, confirmar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
